import type { AssistantVoiceEntityRef } from "~/shared/ai/assistant-voice";
import { ASSISTANT_VOICE_ENTITY_REF_MAX, AssistantVoiceEntityRefSchema } from "~/shared/ai/assistant-voice";
import type { ReportArtifactState } from "./report-artifact-state";

import { activeReportArtifact } from "./report-artifact-state";

export const assistantVoiceEntityRefs = (state: ReportArtifactState): AssistantVoiceEntityRef[] => {
  const artifact = activeReportArtifact(state);
  if (!artifact) {
    return [];
  }
  const references: AssistantVoiceEntityRef[] = [];
  const seen = new Set<string>();

  for (const field of artifact.dataset.fields) {
    if (!field.entityRef) {
      continue;
    }
    for (const row of artifact.dataset.rows) {
      const kind = field.entityRef.entity ?? (field.entityRef.typeKey ? row[field.entityRef.typeKey] : undefined);
      const id = row[field.entityRef.idKey];
      const parsed = AssistantVoiceEntityRefSchema.safeParse({ kind, id });
      if (!parsed.success) {
        continue;
      }
      const key = `${parsed.data.kind}:${parsed.data.id}`;
      if (seen.has(key)) {
        continue;
      }
      references.push(parsed.data);
      seen.add(key);
      if (references.length >= ASSISTANT_VOICE_ENTITY_REF_MAX) {
        return references;
      }
    }
  }

  return references;
};
